import { useAuth0 } from '@auth0/auth0-react';
import { findRoles } from './filtering';
import { namespace } from '../constants/text-values';
import { headRoles } from '../constants/role-values';

// Roles that should have access to vacation/sickness tabs (like project managers)
const vacationSicknessAccessRoles = [
  ...headRoles,
  'Accountant',
  'Head of Accountant',
] as const;

/**
 * Hook to check if user has access to vacation/sickness tabs
 * Includes all head roles plus Accountant and Head of Accountant
 */
export const useVacationSicknessAccess = () => {
  const { user } = useAuth0();
  const extendedRole = findRoles(
    user ? user[`${namespace}/roles`] : null,
    vacationSicknessAccessRoles,
  );
  return extendedRole === true;
};
